module.exports = __webpack_public_path__ + "img/busca-tematica-forrajeras.f1e4f1c0.jpg";